var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "url(#paint0_linear_2264_289)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14,30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.332 8.604c1.224 0 2.216.989 2.216 2.208v17.336c0 1.22-.992 2.208-2.216 2.208a2.212 2.212 0 0 1-2.216-2.208V10.812c0-1.22.992-2.208 2.216-2.208zM7.254-.004c1.231 0 2.229.986 2.229 2.203v6.403h6.522c6.054 0 10.98 4.868 10.98 10.85 0 5.983-4.926 10.85-10.98 10.85-6.055 0-10.98-4.867-10.98-10.85v-6.444h-2.27c-1.232 0-2.23-.986-2.23-2.203 0-1.216.998-2.203 2.23-2.203h2.27V2.2c0-1.217.998-2.203 2.229-2.203zm31.744 0c1.237 0 2.24.986 2.24 2.203v6.403h5.614c1.237 0 2.24.987 2.24 2.203 0 1.217-1.003 2.203-2.24 2.203h-5.614v6.444c0 3.523 2.804 6.353 6.383 6.443 1.237.03 2.214 1.042 2.183 2.258-.032 1.197-1.028 2.146-2.239 2.146h-.058a11.06 11.06 0 0 1-7.61-3.268 10.697 10.697 0 0 1-3.139-7.579v-6.444h-.954c-1.237 0-2.24-.986-2.24-2.203 0-1.216 1.003-2.203 2.24-2.203h.954V2.2c0-1.217 1.003-2.203 2.24-2.203zM16.005 13.008H9.483v6.444c0 3.554 2.926 6.445 6.522 6.445s6.522-2.891 6.522-6.445c0-3.553-2.926-6.444-6.522-6.444z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.88 5.161c0 1.358-1.116 2.46-2.493 2.46-1.377 0-2.493-1.102-2.493-2.46 0-1.358 1.116-2.46 2.493-2.46 1.377 0 2.493 1.102 2.493 2.46M51.757 32.602l9.235-5.092a.579.579 0 0 0-.085-1.052l-9.937-3.577a.39.39 0 0 0-.467.167.389.389 0 0 0-.016.353l1.431 3.294a.682.682 0 0 0 .597.407l4.082.177a.05.05 0 0 1 .048.046.05.05 0 0 1-.04.052l-4.002.816a.678.678 0 0 0-.524.496l-.883 3.476a.39.39 0 0 0 .072.346.39.39 0 0 0 .489.091",
    fill: "#FFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2264_289",
    x1: -4.17232e-7,
    y1: 28,
    x2: 90.9987,
    y2: 90.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBit);
export default __webpack_public_path__ + "static/media/bit.0ccd1a4d79abfcee3e6591fb3a3f2f64.svg";
export { ForwardRef as ReactComponent };